import { MapPin, Phone, Clock, Instagram, ArrowUpRight, PawPrint } from "lucide-react";
import { CONTACT, ESAK_INSTAGRAM } from "../data/content";

export const Footer = () => {
    return (
        <footer id="visit" className="bg-[#262055] text-white pt-24 pb-10 px-6 md:px-10" data-testid="footer-section">
            <div className="max-w-7xl mx-auto">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
                    <div>
                        <img src="/brand/ua-logo-white.webp" alt="Uncover Avenue" className="h-16 w-auto" data-testid="footer-logo" />
                        <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-xs" data-testid="footer-tagline">
                            A retreat in the city, food, laughter and moments that matter, under the trees of Dwarka.
                        </p>
                        <a href="/pets" className="mt-5 inline-flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors" data-testid="footer-pets-link">
                            <PawPrint size={16} className="text-[#F0841B]" /> Pet friendly, see our pet menu
                        </a>
                    </div>

                    <div data-testid="footer-visit-info">
                        <h3 className="text-sm font-bold uppercase tracking-widest text-[#F0841B] mb-6">Visit Us</h3>
                        <ul className="space-y-4 text-sm text-white/75">
                            <li className="flex gap-3">
                                <MapPin size={18} className="shrink-0 text-[#00958C] mt-0.5" />
                                <span data-testid="footer-address">{CONTACT.address}</span>
                            </li>
                            <li className="flex gap-3 items-center">
                                <Phone size={18} className="shrink-0 text-[#00958C]" />
                                <a href={`tel:${CONTACT.phonePrimary.replace(/\s/g, "")}`} className="hover:text-white transition-colors" data-testid="footer-phone-link">{CONTACT.phonePrimary}</a>
                            </li>
                            <li className="flex gap-3 items-center">
                                <Clock size={18} className="shrink-0 text-[#00958C]" />
                                <span data-testid="footer-hours">{CONTACT.hours}</span>
                            </li>
                        </ul>
                    </div>

                    <div data-testid="footer-kitchens">
                        <h3 className="text-sm font-bold uppercase tracking-widest text-[#F0841B] mb-6">Our Kitchens</h3>
                        <ul className="space-y-3 text-sm text-white/75">
                            <li><a href="/#esak" className="hover:text-white transition-colors" data-testid="footer-esak-link">Esak, now serving</a></li>
                            <li className="text-white/40" data-testid="footer-south-indian-soon">South Indian, coming soon</li>
                            <li className="text-white/40" data-testid="footer-pan-asian-soon">Pan Asian, coming soon</li>
                        </ul>
                    </div>

                    <div data-testid="footer-connect">
                        <h3 className="text-sm font-bold uppercase tracking-widest text-[#F0841B] mb-6">Connect</h3>
                        <div className="flex flex-col gap-3">
                            <a
                                href={CONTACT.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors"
                                data-testid="footer-instagram-link"
                            >
                                <Instagram size={18} className="text-[#E21B54]" /> @uncoveravenue
                            </a>
                            <a
                                href={ESAK_INSTAGRAM}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors"
                                data-testid="footer-esak-instagram-link"
                            >
                                <Instagram size={18} className="text-[#E50046]" /> @esak.delhi
                            </a>
                            <a
                                href={CONTACT.mapsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-white transition-colors"
                                data-testid="footer-directions-link"
                            >
                                Get Directions <ArrowUpRight size={16} />
                            </a>
                            <a
                                href="/#reserve"
                                className="mt-4 inline-block self-start rounded-full bg-[#F0841B] text-white text-sm font-semibold px-7 py-3 hover:brightness-110 hover:-translate-y-0.5 transition-[transform,filter] duration-200"
                                data-testid="footer-reserve-button"
                            >
                                Reserve a Table
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40" data-testid="footer-bottom-bar">
                    <p>© {new Date().getFullYear()} Uncover Avenue. All rights reserved.</p>
                    <p className="font-serif-brand italic text-sm text-white/50">Come as you are, leave refreshed and connected.</p>
                </div>
            </div>
        </footer>
    );
};
